function alertParameterProductCategoryCostController(alertsFrameworkService, productsService) {
	const $ctrl = this;

	$ctrl.areProductCategoryCostsLoading = false;

	$ctrl.$onInit = function () {
		loadProductCategoryCosts();

		$ctrl.productCategoryCostKeys = alertsFrameworkService.getKeyArrayFromCsv($ctrl.model);
	};

	/* Handle Model Changes on the Parent */
	$ctrl.$onChanges = function(changes) {
		if (changes.model){
			const newKeys = alertsFrameworkService.getKeyArrayFromCsv(changes.model.currentValue);
			const arraysEqual =
				newKeys.length === $ctrl.productCategoryCostKeys.length
				&& newKeys.every((value, index) => value === $ctrl.productCategoryCostKeys[index]);

			if (!arraysEqual)
			{
				$ctrl.productCategoryCostKeys = newKeys;
			}
		}
    }

	$ctrl.productCategoryCostsChanged = (item, model) => {
        const csvValue = alertsFrameworkService.getCsvFromKeyArray($ctrl.productCategoryCostKeys);

		$ctrl.onUpdate({csvValue: csvValue});
	};

	function loadProductCategoryCosts() {
		$ctrl.areProductCategoryCostsLoading = true;

		return productsService
			.getProductCategoryCosts($ctrl.subscriberKey)
			.then((productCategoryCosts) => {
				$ctrl.productCategoryCosts = productCategoryCosts.toSorted((a, b) => {
                    const nameA = a.productCategoryCostName.toUpperCase();
                    const nameB = b.productCategoryCostName.toUpperCase();

                    if (nameA < nameB) {
                        return -1;
                    }

                    if (nameA > nameB) {
                        return 1;
                    }

                    return 0;
                });

				$ctrl.areProductCategoryCostsLoading = false;
			});
	}
}

angular
	.module("angus.components")
	.component("alertParameterProductCategoryCost", {
		controller: alertParameterProductCategoryCostController,
		bindings: {
			subscriberKey: "<",
			label: "<",
			model: "<",
			isReadOnly: "<",
			onUpdate: "&"
		},
		template: `
<label class="control-label" for="productCategoryCosts">{{$ctrl.label || 'Product Category Cost'}}
    <i class="fa fa-spinner fa-spin" data-fade-toggle="areProductCategoryCostsLoading"></i></label>

<ui-select
    class="alert-select" 
	multiple 
	ng-model="$ctrl.productCategoryCostKeys" 
	ng-disabled="!$ctrl.productCategoryCosts.length || $ctrl.isReadOnly" 
	on-select="$ctrl.productCategoryCostsChanged($item, $model)" 
	on-remove="$ctrl.productCategoryCostsChanged($item, $model)"
>
    <ui-select-match placeholder="Select product category costs...">{{$item.productCategoryCostName}}</ui-select-match>
    <ui-select-choices repeat="productCategoryCost.productCategoryCostKey as productCategoryCost in $ctrl.productCategoryCosts | filter: {productCategoryCostName: $select.search}">
        {{productCategoryCost.productCategoryCostName}}</ui-select-choices>
</ui-select>
		`
	});
